module.exports = (__webpack_require__(14))(4);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/babel-runtime/helpers/extends.js from dll-reference vendor_library
// module id = 76
// module chunks = 0